'use client'

import React, { FC, ReactElement } from 'react'
import styles from './InscriptionWarningMultiInscriptions.module.css'
import WarningModal from '@/components/warning-modal'
import InscriptionCardSmall from '@/components/inscription-card-small'
import { Inscription } from '@/utils/types/inscription'
import classNames from 'classnames'

const InscriptionWarningMultiInscriptions: FC<{
	open: boolean
	onClose: () => void
	inscriptions: Inscription[]
}> = (props): ReactElement => {
	const { onClose, inscriptions } = props

	return (
		<WarningModal
			icon="alert"
			open={props.open}
			onClose={onClose}
			title="There are multiple inscriptions in this UTXO"
			description={<p>You need to split up your ordinals before you can continue.</p>}
			confirmLabel="I understand"
			onConfirm={onClose}
			onCancel={onClose}
			buttonDisplay="confirm-only"
		>
			<div className={styles.content}>
				<div className={classNames(styles.title, 'text-lg', 'semibold')}>
					Items inside single UTXO
				</div>
				<div className={styles.inscriptions}>
					{inscriptions?.map((e, i) => (
						<InscriptionCardSmall key={i} inscription={e} />
					))}
				</div>
			</div>
		</WarningModal>
	)
}

export default InscriptionWarningMultiInscriptions
